import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import React, { useState } from "react"; // Import useState
import { Typography, useMediaQuery } from "@mui/material";
import { Box, IconButton } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const SwiperComp = ({
  id,
  slides,
  startWithImageOnRight = false,
  height,
  isRooms = false,
  isAbout = false,
}) => {
  const [currentIndex, setCurrentIndex] = useState(1); // Stato per tracciare l'indice corrente
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      sx={{
        width: "100vw",
        mt: isAbout ? "none" : "50px",
        height: height || "30vh",
        position: "relative",
      }}
    >
      <Swiper
        speed={900} // Increase the speed value for smoother transitions
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        onSlideChange={(swiper) => setCurrentIndex(swiper.activeIndex + 1)} // Aggiorna l'indice corrente
        navigation={{
          nextEl: `.custom-next-${id}`,
          prevEl: `.custom-prev-${id}`,
        }}
        // pagination={{ clickable: true }}
        // scrollbar={{ draggable: true }}
        style={{ height: "100%", width: "100%" }}
        effect="fade" // Add this line for fade effect
      >
        {slides.map((slide, index) => {
          const isImageOnRight = startWithImageOnRight
            ? index % 2 === 0
            : index % 2 !== 0;

          return (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  display: "flex",
                  height: "100%",
                  width: "100%",
                  flexDirection: isMobile
                    ? "column"
                    : isImageOnRight
                    ? "row-reverse"
                    : "row",
                }}
              >
                {/* Sezione immagine, 70% */}
                <Box
                  sx={{
                    flex: 8,
                    backgroundImage: `url(${slide.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: isRooms
                      ? "20% 50%"
                      : index === 1
                      ? "center"
                      : index >= 2
                      ? "center"
                      : "top",
                    height: "100%",
                  }}
                ></Box>

                {/* Sezione testo, 30% */}
                <Box
                  sx={{
                    gap: 3,
                    flex: 2,
                    backgroundColor: isMobile ? "#F9F9F9FF" : slide.bgColor,
                    display: isRooms ? "none" : "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: isMobile ? 5 : 8,
                    height: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: isMobile ? "#272727" : "white",
                      fontSize: isMobile ? "28px" : "3vw",
                      lineHeight: 1.3,
                      fontStyle: "italic",
                      fontFamily: "ivymode",
                      letterSpacing: "1px",
                      pr: index === 0 ? 0 : 2,
                    }}
                    variant="h3"
                    component="h2"
                  >
                    {slide.title}
                  </Typography>

                  <Typography sx={{ color: "white" }}> {slide.text}</Typography>
                </Box>
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* Frecce e contatore foto */}
      <Box
        sx={{
          position: "absolute",
          bottom: "30px",
          right: "60px",
          display: "flex",
          alignItems: "center",
          zIndex: 10,
        }}
      >
        {/* Freccia per andare indietro */}
        <IconButton
          className={`custom-prev-${id}`}
          sx={{
            color: isMobile ? "#272727" : "white",
            fontSize: "0.8rem",
            padding: "4px",
          }}
        >
          <ArrowBackIosIcon sx={{ fontSize: "16px" }} />
        </IconButton>

        {/* Mostra indice della foto e totale */}
        <Typography
          sx={{
            color: isMobile ? "#272727" : "white",
            fontSize: "0.9rem",
            margin: "0 10px 1px 8px",
          }}
        >
          {currentIndex} / {slides.length}
        </Typography>

        {/* Freccia per andare avanti */}
        <IconButton
          className={`custom-next-${id}`}
          sx={{
            color: isMobile ? "#272727" : "white",
            fontSize: "0.8rem",
            padding: "4px",
          }}
        >
          <ArrowForwardIosIcon sx={{ fontSize: "16px" }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default SwiperComp;
